import React, {
  createContext,
  useEffect,
  useState,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
} from "react";
import { IVoter } from "../domain/voter";
import { API_BASE } from "../const/config";
import { LocalStorageContext } from "./localstorage.provider";
import {
  ILoginToken,
  IActionTokenResponse,
  IViewerVoterApiToken,
} from "../domain/email-token";
import { staticAuthFetch, staticFetch } from "../util/api";
export enum AUTH_STATUS {
  VERIFYING = "VERIFYING",
  AUTHENTICATED = "AUTHENTICATED",
  UNAUTHENTICATED = "UNAUTHENTICATED",
}
export interface IAuthContext {
  authByLoginToken: (organisation_slug: string, voting_round_slug: string, unique_id: string, access_code: string) => Promise<IVoter>;
  voter: IVoter | null;
  status: AUTH_STATUS;
  setToken: (token: any) => void;
}

export interface HttpRequest { }

export const AuthContext = createContext<IAuthContext>({
  authByLoginToken: (code: string) => {
    throw new Error("Not initialized");
  },
  voter: null,
  status: AUTH_STATUS.VERIFYING,
  setToken: (token: any) => null
});
export const AuthProvider: React.FC<PropsWithChildren> = (props) => {
  const { getString, setString, delValue, getKeys } = useContext(LocalStorageContext);
  const publicKey = getString("public_key");
  const secretKey = getString("secret_key");
  const [status, setStatus] = useState<AUTH_STATUS>(AUTH_STATUS.VERIFYING);

  const [voter, setVoter] = useState<IVoter | null>(null);

  const deAuth = () => {
    setStatus(AUTH_STATUS.UNAUTHENTICATED);
    delValue("public_key");
    delValue("secret_key");
  };


  const setToken = useCallback((token: any) => {
    setString("public_key", token.public_key);
    setString("secret_key", token.secret_key);
  }, [setString]);

  const fetchStatus = useCallback(
    async (_publicKey: string, _secretKey: string) => {
      if (!_publicKey || !_secretKey) {
        return;
      }
      try {
        const statusResponse = await staticAuthFetch(
          {
            method: "get",
            url: "/status",
          },
          _publicKey,
          _secretKey
        );

        setVoter(statusResponse.data);
        setStatus(AUTH_STATUS.AUTHENTICATED);
        return statusResponse.data;
      }
      catch (err) {
        deAuth();
      }
    }, [])

  const authByLoginToken = useCallback(
    async (organisation_slug: string, voting_round_slug: string, unique_id: string, access_code: string) => {
      console.log("INITIALIZED");
      const authResponse = await staticFetch<IActionTokenResponse>({
        url: API_BASE + `/access-code/${organisation_slug}/${voting_round_slug}`,
        method: "post",
        data: { unique_id, access_code },
      });

      const { payload } = authResponse.data;
      setToken(payload);
      return fetchStatus(payload.public_key, payload.secret_key)

    }, [setToken]);

  const purgeResponses = useCallback((except?: string) => {
    const keys = getKeys().filter(k => k.startsWith("response_"));
    for (const key of keys) {
      if (!except || !key.includes(except)) {
        delValue(key);
      }
    }
  }, [getKeys, delValue])

  useEffect(() => {
    if (publicKey && secretKey) {
      fetchStatus(publicKey, secretKey)
    } else {
      purgeResponses();
      setStatus(AUTH_STATUS.UNAUTHENTICATED);
    }
  }, [publicKey, secretKey]);


  return (
    <AuthContext.Provider value={{ authByLoginToken, voter, status, setToken }}>
      {props.children}
    </AuthContext.Provider>
  );
};
